
import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { ContactUs } from '../../components/section/ContactUs';
import { CopyrightFooter } from '../../components/section/CopyrightFooter';
import { Container, IAppState } from '../Container';

interface IPublicationsState {
  isLoggedIn: boolean
  username: string
  apiKey: string
  style: any
}

export class Publications extends Container<{}, IPublicationsState> {

  navbarHeight = 50
  topYPosition = 60 - this.navbarHeight
  clientWidth = 794
  clientHeight = 115

  constructor(props) {
    super(props)
    window.addEventListener('scroll', this.adjustTableOfContents.bind(this))
  }

  mapAppStateToContainerState(appState: IAppState): IPublicationsState {
    const isLoggedIn = !!appState.User.username
    const username = appState.User.username
    const position = 'fixed'
    return { isLoggedIn, username, apiKey: appState.User.token, style: { position, top: 115, right: 100, zIndex: 0 } }
  }

  scrollToSection(e) {
    e.preventDefault();
    let id = e.currentTarget.id
    id = id.replace('_link', '')
    document.getElementById(id).scrollIntoView()
  }

  scrollToTop(e) {
    e.preventDefault()
    document.getElementById('tableofcontents').scrollIntoView()
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.adjustTableOfContents)
  }

  adjustTableOfContents() {
    let style: React.CSSProperties = {}
    if (this.topYPosition < window.pageYOffset) {
      const position = 'fixed'
      style = { position, top: 115, right: 100, zIndex: 0 }
    }

    this.setState({ style })
  }

  render() {
    return (
      <section>
        <section className="padding-top-lg padding-bottom">
          <div className="container" style={{ overflowX: 'hidden' }}>
            <Row>
              <Col sm={12}>
                <section id="tableofcontents">
                  <section>
                    <h5>Publications</h5>
                    <ul>
                      <li><a className="link" onClick={this.scrollToSection} id="riot_link">Start a RIOT</a></li>
                      <li><a className="link" onClick={this.scrollToSection} id="needBetterBenchmarks_link">What's In Your Benchmark?</a></li>
                    </ul>
                  </section>
                </section>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <section id="riot">
                  <h3>Performance Benchmarks: Start a RIOT</h3>
                  <section>
                    <span style={{ fontSize: '1.3em' }}><b><u>How are we doing?</u></b></span>
                    <div style={{ float: 'right', color: '#718EA4', fontStyle: 'italic', borderTop: '1px solid #718EA4', borderBottom: '1px solid #718EA4', padding: '25px', minHeight: '250px' }}>
                      <h4 style={{ color: '#718EA4' }}>Benchmark Essentials</h4>
                      <ul>
                        <li>
                          Representative
                        </li>
                        <li>
                          Independent
                        </li>
                        <li>
                          Objective
                        </li>
                        <li>
                          Transparent
                        </li>
                      </ul>
                    </div>
                    <p>
                      If you are a trustee of a private foundation, you’d probably like to know how your foundation’s investment performance compares to other foundations. Considering how much financial data is a mouse click away, this seems like a pretty straightforward question that is bound to have a similarly straightforward answer, right? After all, you really only need two pieces of information 1) your foundation’s performance, and 2) the performance of the foundation market to compare it against.
                      </p>
                    <p>
                      Let’s assume you have the first piece, your performance, now it’s just a matter looking up a good comparison base. The next logical step is to Google “Foundation Investment Performance” (or any variation on that theme) and you should be sitting pretty. Uh-oh.  Google returns a couple of articles that mention foundation performance followed by a number of firms who’d like to help manage your foundation’s assets, but not a lot of information on how foundations are actually performing.
                    </p>
                    <p>
                      If you are not the type to give up easily, you might try doing a more exhaustive search, and look past the first page of hits on Google.  In this deeper dive, you will discover a few organizations that publish some information that may be of use—notably the Northern Trust Foundation and Endowment Universe, the BNY Mellon US Master Trust, and the Council on Foundations–Commonfund Study of Investment of Endowments for Private and Community Foundations (mercifully abbreviated to “CCSF”).
                      </p>
                    <p>
                      Whew! Now you just have to look at your performance and compare it to the data from one of the providers and you will be home free.
                    </p>
                    <p>
                      But wait, as you read through the documents and glance at the tables, you notice things like “average plan size of $5.1 billion” or “Composite Asset Allocation to Private Equity/Hedge Funds: 46%”, you might start to wonder “are these really appropriate benchmarks for us?”. Unless your foundation has hundreds of millions of dollars in invested in private equity, venture capital and hedge funds, they probably aren’t. So why should you compare your foundation to them? Put another way, these seem to be measuring funds that are 50% in alternative assets.
                    </p>
                    <p>
                      You could either give up or start a <b>RIOT</b>, which is what we did at FoundationMark.
                    </p>
                    <p>
                      What are the hallmarks of a comprehensive benchmark? We think there are 4 mandatory components.  Benchmarks need to be <b><u>R</u></b>epresentative, <b><u>I</u></b>ndependent, <b><u>O</u></b>bjective, and <b><u>T</u></b>ransparent.  <b>RIOT</b>. Think of the best known benchmarks, and what makes them useful.
                    </p>
                    <div style={{ float: 'left', border: '1px solid', backgroundColor: '#e9e9e9', padding: '5px', marginRight: '10px' }}>
                      <ul>
                        <li>
                          Representative
                          <ul>
                            <li>Do the components match the market?</li>
                          </ul>
                        </li>
                        <li>
                          Independent
                          <ul>
                            <li>Do the publishers have any potential conflicts of interest?</li>
                          </ul>
                        </li>
                        <li>
                          Objective
                          <ul>
                            <li>Is there any bias in the selection process?  Are calculations universally applied? </li>
                          </ul>
                        </li>
                        <li>
                          Transparent
                          <ul>
                            <li>Can we verify the data? Who is included?</li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                    <p>
                      Returning to the plight of the trustee, now a detailed report comparing performance and expense metrics is a single click away. If you are a trustee of a foundation click <a href="#/are-you-foundation">here</a> to request your free report.                    </p>
                  </section>
                </section>
                <a style={{ cursor: 'pointer' }} onClick={this.scrollToTop}>Back to table of contents</a>
              </Col>
            </Row>
            <Row className="margin-y" style={{ boxShadow: '0 2px 4px 0 #e9e9e9' }}>
              <Col sm={12}>
                <section id="needBetterBenchmarks">
                  <h3>What's In Your Benchmark?</h3>
                  <section>
                    <div style={{ float: 'right', border: '1px solid', backgroundColor: '#e9e9e9', padding: '5px', marginLeft: '10px', width: '70%' }}>
                      <img className="img-fluid" src="/assets/img/equitiesaspercent.png" alt="10 Year History of Equities as Percent of Assets" style={{ maxWidth: '100%', height: 'auto' }} />
                      <img className="img-fluid" src="/assets/img/assetallocationexamples.png" alt="Asset Allocations Examples" style={{ maxWidth: '100%', height: 'auto' }} />
                    </div>
                    <p>
                      The single most important characteristic of a benchmark is that it should be representative of the group that it is designed to measure.
                    </p>
                    <p>
                      The chart at right shows the development of foundations allocation to public equities over the 10 year period from 2007 to 2016.  The chart shows that on average, foundations with asset of over $1 billion reduced their exposure to equities from about 50% to 35%, while every other asset group maintained allocations in the 50—65% range (apart fromn the 2008 lows).  What happened to the money that foundations had in equities? Much of it, about 40% on average, is in alternative asset classes.
                    </p>
                    <p style={{ fontSize: '1.3em' }}>
                      Which is More Representative?
                    </p>
                    <p>
                      There are fewer than 100 foundations that have over $1 billion in assets, or just 0.2% of the FoundationMark Universe.
                      The existing publicly available measures of foundation performance (see below) use samples drawn from the largest foundations (and may include non foundation assets), and therefore measure the performance of a fraction of the foundation universe.
                    </p>
                    <p style={{ fontSize: '1.3em' }}>
                      What is Being Measured?
                    </p>
                    <p>
                      Consider the fact that any measure of performance is merely the sum of its constituent parts. For example the S&P 500 measures the performance of 500 large cap stocks. Therefore it follows that an index comprised of 40% or higher exposure to hedge funds, private equity, and real estate measures the underlying performance of those asset classes.
                    </p>
                    <p>
                      If a foundation has $1 billion, nearly half of which is invested in alternatives, the existing indices are a good fit. If not, the foundation would likely benefit from a more representative benchmark.
                      FoundationMark provides indices and peer group analysis to help foundations better benchmark their investment performance.

                    </p>
                    <p style={{ padding: '10px' }}>
                      <img className="img-fluid" src="/assets/img/benchmarktable.png" alt="Benchmark" style={{ maxWidth: '100%', width: '100%', height: 'auto' }} />
                    </p>
                  </section>
                </section>
              </Col>
            </Row>
            <a style={{ cursor: 'pointer' }} onClick={this.scrollToTop}>Back to table of contents</a>
          </div>
        </section>

        <footer>
          <ContactUs />
          <CopyrightFooter />
        </footer>
      </section >
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Publications/index.tsx